import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import { CreateDateObject, filterEndTimes, filterStartTimes, ValidateTimes } from '../../../../exl/LectureHelperFunctions';
import { end } from '@popperjs/core';
import { useTranslation } from 'react-i18next';
import { DATE_PLACEHOLDER, EDIT_DATE_TIME_LECTURE_DATE_LABEL, EDIT_DATE_TIME_LECTURE_END_LABEL, EDIT_DATE_TIME_LECTURE_START_LABEL } from '../../../../../i18n/keyConstants';

registerLocale('sv', sv);

const EditDateTime = ({ value, setValue, onKeyDown, isInvalid, onSave, autoFocus }) => {

    const datePickerFormat = 'yyyy-MM-dd';
    const timePickerFormat = 'HH:mm';
    const [date, setDate] = useState();
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const { t } = useTranslation(['editDateTime', 'shared']);
    useEffect(() => {
        if (!!startTime && !!endTime  && !!date && ValidateTimes(startTime, endTime)) {
            setValue(CreateDateObject(date, startTime, endTime));
        }
    }, [startTime, endTime, date]);

    const inputRef = useRef();
    const handleFocus = () => {
        if (inputRef?.current) {
            inputRef.current.input.select();
        }
    };
    useEffect(() => {
        autoFocus && handleFocus();
        if (value) {
            setDate(new Date(value.from));
            setStartTime(new Date(value.from));
            setEndTime(new Date(value.to));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='crm-editable-field-wrapper'>
            <span>{t(EDIT_DATE_TIME_LECTURE_DATE_LABEL)}</span>
            <DatePicker
                dateFormat={datePickerFormat}
                selected={date}
                onChange={(date) => setDate(date)}
                locale={localStorage.getItem('userLocale')}
                showMonthDropdown={true}
                showYearDropdown={true}
                placeholderText={t(DATE_PLACEHOLDER, {ns: 'shared'})}
                ref={inputRef}
                className={`text-input ${isInvalid ? 'invalid' : ''}`}
                onKeyDown={onKeyDown}
                
            />
            <span>{t(EDIT_DATE_TIME_LECTURE_START_LABEL)}</span>
            <DatePicker
                dateFormat={timePickerFormat}
                selected={startTime ? startTime : null}
                onChange={(date) => setStartTime(date)}
                locale={localStorage.getItem('userLocale')}
                showTimeSelect
                showTimeSelectOnly
                placeholderText='00:00'
                className={`text-input ${isInvalid ? 'invalid' : ''}`}
                onKeyDown={onKeyDown}
                timeIntervals={15}
                timeCaption="Time"
                minTime={new Date().setHours(0, 0, 0, 0)}
                maxTime={endTime ? endTime : new Date().setHours(23, 59, 59, 59)}
                excludeTimes={endTime ? [endTime] : [] }
            />
            <span>{t(EDIT_DATE_TIME_LECTURE_END_LABEL)}</span>
            <DatePicker
                dateFormat={timePickerFormat}
                selected={endTime ? endTime : null}
                onChange={(date) => setEndTime(date)}
                locale={localStorage.getItem('userLocale')}
                showTimeSelect
                showTimeSelectOnly
                placeholderText='00:00'
                className={`text-input ${isInvalid ? 'invalid' : ''}`}
                onKeyDown={onKeyDown}
                timeIntervals={15}
                timeCaption="Time"
                minTime={startTime ? startTime : new Date().setHours(0, 0, 0, 0)}
                maxTime={new Date().setHours(23, 44, 59, 59)}
                excludeTimes={startTime ? [startTime] : []}
            />
        </div>
    );
};

export default EditDateTime;
